import React, { FC } from 'react';
import type { PaymentAddon as PaymentAddonType } from 'src/types/trips/PaymentAddon';
import formatPaymentAddons from 'src/inbox/components/PaymentAddon/helper';
import PaymentAddon from '../PaymentAddon';
import s from './PaymentAddons.module.scss';

type PaymentAddonsProps = {
  addons: PaymentAddonType[];
  isOwner: boolean;
};

/** Opinionated JSX with root container and border bottom styling */
const PaymentAddons: FC<PaymentAddonsProps> = ({
  addons,
  isOwner,
}) => (
  <div className={s.root}>
    {addons?.map((addon) => (
      <PaymentAddon
        key={addon.pk}
        {...formatPaymentAddons({ addon, isOwner })}
      />
    ))}
  </div>
);

export default PaymentAddons;
